import React from "react";
import Header from "../components/ui/Header";
import { welcomeText } from "../data/config";

const ClockSkewError = () => {
  const isMobile = window.matchMedia("(max-width: 600px)").matches;
  const marginTop = {
    marginTop: isMobile ? "20px" : "",
  };

  return (
    <>
      <Header isMember={false} />
      <div style={{ position: "relative" }}>
        <div className="grid-container" id={isMobile ? "join-banner" : ""}>
          <div className="grid-x grid-margin-x align-center">
            <div className="cell large-7 text-center">
              <div style={{ paddingBottom: "4rem" }}>{welcomeText}</div>
            </div>
          </div>
        </div>
      </div>
      <div className="grid-container join-content">
        <div className="grid-x grid-margin-x align-center">
          <div className="cell large-10 xlarge-9">
            <div className="box">
              <div className="page is-active is-loaded" style={marginTop}>
                <div className="box-header">
                  <legend>Session Verification Failed</legend>
                </div>
                <div className="box-content">
                  <fieldset className="box-section">
                    <h3 className="box-section-heading">
                      We were unable to verify your session.
                    </h3>
                    <p className="input-wrapper">
                      This is usually caused by your device's date and time
                      being set incorrectly. Please check that your device's
                      date, time, and time zone are set correctly and try again.
                    </p>
                    <p className="input-wrapper">
                      <strong>To fix this on Windows:</strong> Right-click the
                      clock in your taskbar → Adjust date/time → enable "Set
                      time automatically".
                    </p>
                    <p className="input-wrapper">
                      <strong>To fix this on Mac:</strong> System
                      Preferences → Date &amp; Time → enable "Set date and time
                      automatically".
                    </p>
                    <p className="input-wrapper">
                      If your date and time are correct and you continue to have
                      issues, please contact our membership department at (512)
                      505-0242 or submit an online request for assistance{" "}
                      <a href="https://ask.aanp.org/membership">here</a>.
                    </p>
                    <div
                      className="text-center"
                      style={{ marginTop: "20px" }}
                    >
                      <button
                        type="button"
                        className="button"
                        onClick={() => (window.location.href = "/start")}
                      >
                        Try Again
                      </button>
                    </div>
                  </fieldset>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ClockSkewError;
